"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const de_ui_1 = require("@delab-team/de-ui");
const button_module_css_1 = __importDefault(require("./button.module.css"));
const Button = ({ onClick, loading, children, disabled, className, ...rest }) => ((0, jsx_runtime_1.jsx)(de_ui_1.Button, { className: `${button_module_css_1.default.button} ${className}`, disabled: disabled, loading: loading, onClick: onClick, ...rest, children: children }));
exports.Button = Button;
